import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { Premix } from './premixes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/premix');

export const getPremixList = actionCreator.async<any, Premix[]>('[GET_PREMIX_LIST]');
export const getPremix = actionCreator.async<any, Premix>('[GET_PREMIX]');

export const createPremix = actionCreator.async<FormName, any>('[CREATE_PREMIX]');
export const editPremix = actionCreator.async<FormName, any>('[EDIT_PREMIX]');
export const renamePremix = actionCreator.async<FormName, any>('[RENAME_PREMIX]');
export const deletePremix = actionCreator.async<FormName, any>('[DELETE_PREMIX]');
